<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
            <bita-input
              type="text"
              name="load_code"
              label="کد بار"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.load_code"
            />
            <bita-select
              v-if="categories.length > 0"
              name="categories"
              label="دسته بندی"
              rules="required"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="categories"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.parent_id"
            />
              <bita-select
              name="check_ebl"
              label="آیا بارنامه چک شود؟"
              placeholder="آیا بارنامه چک شود؟"
              :validation-container-class="colWidth"
              input-class="form-control"
              data-text-field="title"
              data-value-field="id"
              :data-source="items"
              v-model="dataForm.check_ebl"
              rules="required"
            />
            <!-- <bita-multiselect
              v-if="this.$acl.isSuperAdmin"
              name="users"
              label="انتخاب کاربر"
              validation-container-class="col-12"
              input-class="form-control"
              :data-source="propsUser"
              data-text-field="full_name"
              v-model="dataForm.owner_id"
              data-value-field="model_id"
            /> -->
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!propsData.id"
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        v-if="propsData.id"
        type="primary"
        title="بروزرسانی"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    categories: {
      type: Array,
      default: [],
    },
    propsData: {
      type: Object,
      default: {
        name: "",
        load_code:"",
        parent_id: "",
      },
    },
    propsUser: { type: Array, default: [] },
  },
  data() {
    return {
      colWidth: "col-lg-4",
      dataForm: {},
    };
  },
    computed: {
    items: () => {
      return [
        { id: 0, title: "خیر" },
        { id: 1, title: "بله" },
      ];
    },
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>
